/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-part-number-changes-additional-input',
    templateUrl: './part-number-changes-additional-input.component.html',
    styleUrls: ['./part-number-changes-additional-input.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class PartNumberChangesAdditionalInputComponent {
    @Output() deleteClick = new EventEmitter<void>();
    @Input() labelNew: string;
    @Input() labelAdditional: string;
    @Input() additionalTypeCypressTag: string;
    @Input() baseClass: string;
    @Input() additionalIndex?: number;
    @Input() isInViewMode: boolean;
    @Input() isDetailMode: boolean;
    @Input() isSolvedStatus: boolean;
    @Input() isDetailSolvedTrial: boolean;
    @Input() isSolutionAccepted: boolean;

    readonly CSS_ADDITIONAL_CLASS = 'additional';
    readonly CSS_NEW_CLASS = 'new';
    readonly CSS_VIEW_MODE = 'view';
    readonly CSS_VIEW_SOLUTION_TRIAL_MODE = 'view-solution-trial';
    readonly CSS_DETAIL_MODE = 'detail';
    readonly CSS_SOLVED_CLASS = 'solved';

    delete(): void {
        this.deleteClick.emit();
    }

    get isAdditional(): boolean {
        return this.additionalIndex != null;
    }

    get showCloseButton(): boolean {
        return this.isAdditional && !this.isInViewMode;
    }

    get containerTypeClass(): string {
        let containerClass = `${this.baseClass}`;

        if (this.isInViewMode && !this.isDetailSolvedTrial) {
            containerClass = `${containerClass} ${this.CSS_VIEW_MODE}`;
            if (this.isSolutionAccepted && this.isSolvedStatus) {
                containerClass = `${containerClass} ${this.CSS_SOLVED_CLASS}`;
            }
        } else {
            if (this.isDetailSolvedTrial) {
                containerClass = `${containerClass} ${this.CSS_VIEW_SOLUTION_TRIAL_MODE}`;
            }
            if (this.isDetailMode) {
                containerClass = `${containerClass} ${this.CSS_DETAIL_MODE}`;
            }
            if (this.isAdditional) {
                containerClass = `${containerClass} ${this.CSS_ADDITIONAL_CLASS}`;
            } else {
                containerClass = `${containerClass} ${this.CSS_NEW_CLASS}`;
            }
        }
        return containerClass;
    }

    get baseCypressTag(): string {
        return this.isAdditional ? `${this.additionalTypeCypressTag}-${this.additionalIndex}` : this.additionalTypeCypressTag;
    };
}
